module.exports = __webpack_public_path__ + "media/images/platforms/playstation/square-6a1cc929828e6a1a59abcea55716aacc.jpg";